import React, { Component } from 'react';
import ManageDistributor from '../../components/css/dark/img/theme-images/manage-distributor.svg';
import Clients from '../../components/css/dark/img/theme-images/clients.svg';
import ManageGroupNumber from '../../components/Wholesaler/ManageGroupNumber';
import GlicApi from '../../components/Wholesaler/GlicApi';
import Popup from '../../components/Popup';
import SubDisPopup from '../../components/SubDisPopup';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import AssignGroupPopup from '../../components/Wholesaler/AssignGroupNumber';
import EditScreenPopup from '../../components/Wholesaler/OveridePopup';
import CampaignPopup from '../../components/Wholesaler/CampaignPopup';
import BrokerSignaturePopup from '../../components/Wholesaler/BrokerSignature';
import ConfirmationPopup from '../../components/Wholesaler/GroupConfirmationPopup';
import $ from 'jquery';
import RepPopup from '../../components/Wholesaler/RepPopupNew';
import RequestGroupNumber from '../../components/Wholesaler/RequestGroupNumber';
import CommissionPopup from '../../components/Wholesaler/CommissionPopup';
import CommissionAllBinPopup from '../../components/Wholesaler/CommissionAllBinPopup';
import ResetPasswordPopup from '../../components/ChangePassword';
import ManageUserPopup from '../../components/ManageUser';
import Commission from '../../components/css/dark/img/theme-images/commission.svg';
import ChangePassword from '../../components/css/dark/img/theme-images/change-password.svg';
import ApiIcon from '../../components/css/dark/img/theme-images/api-icon.svg';
import Settings from '../../components/css/dark/img/theme-images/settings.svg';
import DeletePopup from '../../components/ConfirmDeletePopup';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import GlicAddApi from './GlicAddApiPopup';

class Tools extends Component {
    constructor(props) {
        super(props);
        try {
            this.state = {
                // users: null,
                dashboardListRendered: false,
                dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
                DisshowPopup: false,
                NewDisshowPopup: false,
                SubDisshowPopup: false,
                toggleCommissionPopup: false,
                toggleCommissionAllBinPopup: false,
                istoggleResetPasswordPopup: false,
                istoggleManageUserPopup: false,
                userdata: JSON.parse(localStorage.getItem('user')),
                toggleRepPopup: false,
                toggleEditScreenPopup: false,
                toggleCampaignPopup: false,
                toggleAssignGroupPopup: false,
                SelectedGroup: '',
                TopCommission: '',
                manageGroupPagin: '',
                mGroupSearchText: '',
                iscalled: false,
                CommissionSeparate: [],
                AvailMonths: [],
                toggleResetScreenPopup: false,
                confirmReset: '',
                deleteIndex: '',
                confirmDelete: '',
                confirmSection: '',
                DeletePopup: '',
                ManageUserName: '',
                ManageUserEmail: '',
                ManageUserId: '',
                ManageUserTitleText: '',
                ManageUserSection: '',
                ManageUserPagin: '',
                ManageUserSearch: '',
                ManageUserPassword: '',
                ManageUserList: '',
                confirmationText: '',
                confirmUser: '',
                toggleSignaturePopup: false,
                brokerUserName: '',
                _reopenFlag: '',
                _allData: '',
                isGlicAPI: false,
                GlicApiPopup: false,
                glicApiData: [],
                glicApiIPs: [],
                safeData: '',
                assignType: '',
                DisEmail: '',
                addApiModalToggle: false,
                stype: false
            };
        }
        catch (error) { }
        this.toggleCommissionPopup = this.toggleCommissionPopup.bind(this);
        this.toggleCommissionAllBinPopup = this.toggleCommissionAllBinPopup.bind(this);
    }

    componentDidUpdate(prevProp) {
        //if (this.state.ActiveJson.length == 0 && this.state.InActiveJson.length == 0 && this.state.iscalled == false ) {
        //    this.GetRepsDetail();
        //}
    }
    safeData = (clientSecret) => {
        let stars = clientSecret.replace(/./g, '*');
        let pClientSecret = stars;
        return pClientSecret;
    }
    componentDidMount() {
        document.title = 'Tools Page';
        $(".analytics-menu").click(e => {
            if ($('.collapseButton').hasClass("active")) {
                this.handleCollapse();
                $('.sidebar-submenu').show();
                $('body').toggleClass('sub-menu-active');
            }
        });
        setTimeout(function () {
            const hasScrollbar = document.body.scrollHeight > window.innerHeight;
            if (!hasScrollbar) {
                $('body').addClass('hide-scroller');
            }
        }, 300);
        // this.GetCommission_Separate(this.state.userdata.wholesaler,''l);
        //this.GetRepsDetail();        

        // check if userdate null    
        if (userService.Check_LoggedIn_Status() == 'Login') {
            return <Redirect to="/login" />
        } else {
            this.GetWh_GlicAPI(parseInt(this.state.userdata.wholesaler_Id), this.state.userdata.email);
        }
    }
    componentWillUnmount() {
        $('body').removeClass('hide-scroller');
    }
    GetWh_GlicAPI(wh_id, wh_email) {
        try {
            userService.Wh_GlicAPI(wh_id, wh_email).then(
                apidata => {
                    if (apidata.length > 0) {
                        let protectedData = this.safeData(apidata[0].apiAcess[0].client_Secret);
                        this.setState({ isGlicAPI: apidata[0].isapiAccess, glicApiData: apidata[0].apiAcess, glicApiIPs: apidata[0].iPs, safeData: protectedData });
                    }
                }
            );
        }
        catch (error) { }
    }
    GetRepsDetail() {
        try {
            fetch('https://cnd.23byt.es/ws/Reps?wname=' + this.state.userdata.wholesaler)
                .then(response => response.json())
                .then(data => {
                    if (data != null && data.length > 0) {
                        this.setState({ ActiveJson: JSON.parse(data[0]["ActiveJson"]), InActiveJson: JSON.parse(data[0]["InactiveJson"]), iscalled: true });
                    }
                    else {
                        this.setState({ ActiveJson: [], InActiveJson: [], iscalled: true });
                    }
                });
        }
        catch (error) {
        }
    }
    GetCommission_Separate(whname, mname) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ whname, mname })
        };
        return fetch('/api/ws/wh_commission_type', requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ CommissionSeparate: apidata[0]["commList"], AvailMonths: apidata[0]["monthList"] });
                }
                catch (error) {
                }
            });
    }
    toggleNewDisPopup(sGroupNumber, topCommission, mGroupPagin, search, cText, chkUser, reopenFlag, allData) {
        var wname = this.state.userdata.wholesaler;
        if (this.state.NewDisshowPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    NewDisshowPopup: !this.state.NewDisshowPopup,
                    dashboardName: wname,
                    SelectedGroup: sGroupNumber,
                    manageGroupPagin: mGroupPagin,
                    TopCommission: topCommission,
                    mGroupSearchText: search,
                    confirmReset: cText,
                    confirmSection: cText,
                    confirmUser: chkUser,
                    _reopenFlag: reopenFlag,
                    _allData: allData
                });
            }, 500)
        } else {
            this.setState({
                NewDisshowPopup: !this.state.NewDisshowPopup,
                dashboardName: wname,
                SelectedGroup: sGroupNumber,
                manageGroupPagin: mGroupPagin,
                TopCommission: topCommission,
                mGroupSearchText: search,
                confirmReset: cText,
                confirmSection: cText,
                confirmUser: chkUser,
                _reopenFlag: reopenFlag,
                _allData: allData
            });
        }
        $('body').toggleClass('modal-on');
    }
    toggleDisPopup() {
        var wname = this.state.userdata.wholesaler;
        this.setState({
            DisshowPopup: !this.state.DisshowPopup,
            dashboardName: wname
        });
        $('body').toggleClass('modal-on');
    }
    toggleSubDisPopup() {
        var wname = this.state.userdata.wholesaler;
        this.setState({
            SubDisshowPopup: !this.state.SubDisshowPopup,
            dashboardName: wname
        });
        $('body').toggleClass('modal-on');
    }
    toggleRepPopup() {
        var wname = this.state.userdata.wholesaler;
        if (this.state.toggleRepPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    toggleRepPopup: !this.state.toggleRepPopup,
                    dashboardName: wname
                });
            }, 500)
        } else {
            this.setState({
                toggleRepPopup: !this.state.toggleRepPopup,
                dashboardName: wname
            });
        }
        $('body').toggleClass('modal-on');
    }
    toggleCommissionPopup() {
        var wname = this.state.userdata.wholesaler;
        if (this.state.toggleCommissionPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    toggleCommissionPopup: !this.state.toggleCommissionPopup,
                    dashboardName: wname
                });
            }, 500)
        } else {
            this.setState({
                toggleCommissionPopup: !this.state.toggleCommissionPopup,
                dashboardName: wname
            });
        }
    }
    toggleCommissionAllBinPopup() {
        var wname = this.state.userdata.wholesaler;
        if (this.state.toggleCommissionAllBinPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    toggleCommissionAllBinPopup: !this.state.toggleCommissionAllBinPopup,
                    dashboardName: wname
                });
            }, 500)
        } else {
            this.setState({
                toggleCommissionAllBinPopup: !this.state.toggleCommissionAllBinPopup,
                dashboardName: wname
            });
        }
    }
    toggleResetPasswordPopup() {
        var wname = this.state.userdata.wholesaler;
        if (this.state.WhshowPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    istoggleResetPasswordPopup: !this.state.istoggleResetPasswordPopup,
                    dashboardName: wname
                });
            }, 500)
        } else {
            this.setState({
                istoggleResetPasswordPopup: !this.state.istoggleResetPasswordPopup,
                dashboardName: wname
            });
        }
        $('body').toggleClass('modal-on');
    }
    toggleManageUserPopup(userName, userEmail, userId, titleText, confirmSection, pagin, search, password) {
        if (this.state.istoggleManageUserPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    istoggleManageUserPopup: !this.state.istoggleManageUserPopup,
                    ManageUserName: userName,
                    ManageUserEmail: userEmail,
                    ManageUserId: userId,
                    ManageUserTitleText: titleText,
                    ManageUserSection: confirmSection,
                    ManageUserPagin: pagin,
                    ManageUserSearch: search,
                    ManageUserPassword: password,
                    ManageUserList: ''
                });
            }, 500)
        } else {
            this.setState({
                istoggleManageUserPopup: !this.state.istoggleManageUserPopup,
                ManageUserName: userName,
                ManageUserEmail: userEmail,
                ManageUserId: userId,
                ManageUserTitleText: titleText,
                ManageUserSection: confirmSection,
                ManageUserPagin: pagin,
                ManageUserSearch: search,
                ManageUserPassword: password,
                ManageUserList: ''
            });
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $(".collapseButton").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    toggleEditGroupPopup(dIndex, cSection, confirmation, userDataList, userType, sGroup) {
        this.setState({
            toggleEditScreenPopup: !this.state.toggleEditScreenPopup,
            deleteIndex: dIndex,
            confirmSection: cSection,
            confirmDelete: confirmation,
            ManageUserList: userDataList,
            assignType: userType,
            SelectedGroup: sGroup
        });
        $('body').toggleClass('modal-on');
    }
    toggleCampaignPopup(dIndex, cSection, confirmation, userDataList, userType, disMail) {
        this.setState({
            toggleCampaignPopup: !this.state.toggleCampaignPopup,
            deleteIndex: dIndex,
            confirmSection: cSection,
            confirmDelete: confirmation,
            ManageUserList: userDataList,
            assignType: userType,
            DisEmail: disMail
        });
        $('body').toggleClass('modal-on');
    }
    toggleAssignGroupPopup(dIndex, cSection, confirmation, UserDataList) {
        if (this.state.WhshowPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    toggleAssignGroupPopup: !this.state.toggleAssignGroupPopup,
                    deleteIndex: dIndex,
                    confirmSection: cSection,
                    confirmDelete: confirmation,
                    ManageUserList: UserDataList,
                    selectedGroup: dIndex
                });
                $('body').toggleClass('modal-on');
            }, 500)
        } else {
            this.setState({
                toggleAssignGroupPopup: !this.state.toggleAssignGroupPopup,
                deleteIndex: dIndex,
                confirmSection: cSection,
                confirmDelete: confirmation,
                ManageUserList: UserDataList,
                selectedGroup: dIndex
            });
            $('body').toggleClass('modal-on');
        }
    }
    toogleResetGroupPopup = (confirmMessage, sGroup) => {
        this.setState({
            toggleResetScreenPopup: !this.state.toggleResetScreenPopup,
            confirmationText: confirmMessage,
            SelectedGroup: sGroup
        });
        $('body').toggleClass('modal-on');
    }
    deletePopup = e => {
        this.setState({
            DeletePopup: !this.state.DeletePopup
        });
        $('body').toggleClass('modal-on');
    }
    brokerSignaturePopup = (sGroupNumber, userName, UserDataList) => {
        this.setState({
            SelectedGroup: sGroupNumber,
            brokerUserName: userName,
            ManageUserList: UserDataList,
            toggleSignaturePopup: !this.state.toggleSignaturePopup
        });
        $('body').toggleClass('modal-on');
    }
    toggleGlicApiPopup() {
        if (this.state.GlicApiPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    GlicApiPopup: !this.state.GlicApiPopup,
                });
            }, 500)
        } else {
            this.setState({
                GlicApiPopup: !this.state.GlicApiPopup,
            });
        }
    }

    toggleGlicApiAddPopup() {
        if (this.state.addApiModalToggle === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.toggleGlicApiPopup()
                this.setState({
                    addApiModalToggle: false,
                });
            }, 500)
        } else {
            this.setState({
                addApiModalToggle: true,
            });
        }
    }

    stypeChanged(stype) {
        if (stype) this.setState({ stype })
    }

    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div>
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="tool-section manage-icon">
                    <h2>Tools <span className="beta-link"><span className="beta">Beta</span></span></h2>
                    <ul>
                        {<li onClick={this.toggleNewDisPopup.bind(this)}><div className="manage-content"><img src={ManageDistributor} alt="" />Manage Group Numbers<span className="arrow">&nbsp;</span></div></li>}
                        <li onClick={this.toggleManageUserPopup.bind(this)}><div className="manage-content"><img src={Settings} alt="" />Manage Users<span className="arrow">&nbsp;</span></div></li>
                        {/*<li onClick={this.toggleDisPopup.bind(this)}><div className="manage-content"><img src={ManageDistributor} alt="" />Manage Distributors<span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.toggleSubDisPopup.bind(this)}><div className="manage-content"><img src={ManageDistributor} alt="" />Manage <br />Sub-Distributors<span className="arrow">&nbsp;</span></div></li>*/}
                        <li onClick={this.toggleRepPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Reps<span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.toggleCommissionPopup.bind(this)}><div className="manage-content"><img src={Commission} alt="" />Wholesaler <br />Commission<span className="arrow">&nbsp;</span></div></li>
                        {this.state.userdata.wholesaler_Id === 61 ?
                            <li onClick={this.toggleCommissionAllBinPopup.bind(this)}><div className="manage-content"><img src={Commission} alt="" />Wholesaler <br />Commission All Bin<span className="arrow">&nbsp;</span></div></li>
                            : null
                        }
                        <li onClick={this.toggleResetPasswordPopup.bind(this)}><div className="manage-content"><img src={ChangePassword} alt="" />Reset Password<span className="arrow">&nbsp;</span></div></li>
                        {
                            this.state.isGlicAPI == true ?
                                <li onClick={this.toggleGlicApiPopup.bind(this)}><div className="manage-content"><img src={ApiIcon} alt="Api Icon" />Glic Health API<span className="arrow">&nbsp;</span></div></li> : null
                        }
                    </ul>
                    {
                        this.state.NewDisshowPopup ?
                            <ManageGroupNumber reopenFlag={this.state._reopenFlag} allData={this.state._allData} text='Manage Group Numbers' confirmText={this.state.confirmReset} selectedGroup={this.state.SelectedGroup} mGroupSearch={this.state.mGroupSearchText} mGroupPagin={this.state.manageGroupPagin} openResetGroup={this.toogleResetGroupPopup.bind(this)} openAssignGroup={this.toggleAssignGroupPopup.bind(this)} openCampaign={this.toggleCampaignPopup.bind(this)} openEditGroup={this.toggleEditGroupPopup.bind(this)} closePopup={this.toggleNewDisPopup.bind(this)} /> : null
                    }
                    {
                        this.state.DisshowPopup ?
                            <Popup text='Configure Distributors' wholesaler_name={this.state.dashboardName} closePopup={this.toggleDisPopup.bind(this)} /> : null
                    }
                    {
                        this.state.SubDisshowPopup ?
                            <SubDisPopup text='Configure Sub-Distributors' wholesaler_name={this.state.dashboardName} SubDisclosePopup={this.toggleSubDisPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleRepPopup ?
                            <RepPopup text='Active & Inactive Reps' calldata={"callonce"} closePopup={this.toggleRepPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleCommissionPopup ?
                            <CommissionPopup text='Wholesaler Commission' calldata={"callonce"} closeCommissionPopup={this.toggleCommissionPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleCommissionAllBinPopup ?
                            <CommissionAllBinPopup text='Wholesaler Commission All Bin' calldata={"callonce"} closeCommissionAllBinPopup={this.toggleCommissionAllBinPopup.bind(this)} /> : null
                    }
                    {
                        this.state.istoggleResetPasswordPopup ?
                            <ResetPasswordPopup text='Reset Password' calldata={"callonce"} closeResetPasswordPopup={this.toggleResetPasswordPopup.bind(this)} /> : null
                    }
                    {
                        this.state.istoggleManageUserPopup ?
                            <ManageUserPopup manageUserPassword={this.state.ManageUserPassword} text='Manage Users' manageUserSearch={this.state.ManageUserSearch} manageUserPagin={this.state.ManageUserPagin} manageUserName={this.state.ManageUserName} manageUserEmail={this.state.ManageUserEmail} manageUserId={this.state.ManageUserId} confirmSection={this.state.ManageUserSection} openDeletePopup={this.deletePopup.bind(this)} calldata={"callonce"} closeResetPasswordPopup={this.toggleManageUserPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleEditScreenPopup ?
                            <EditScreenPopup userType={this.state.assignType} reopenFlag={this.state._reopenFlag} allData={this.state._allData} userLists={this.state.ManageUserList} chkUser={this.state.confirmUser} text={'Manage ' + this.state.SelectedGroup} dIndex={this.state.deleteIndex} confirmationText={this.state.confirmDelete} openBrokerSignature={this.brokerSignaturePopup.bind(this)} openResetGroup={this.toogleResetGroupPopup.bind(this)} cSearch={this.state.mGroupSearchText} cPagin={this.state.manageGroupPagin} SelectedGroupNumber={this.state.SelectedGroup} MaxComm={this.state.TopCommission} openManageGroup={this.toggleNewDisPopup.bind(this)} closeEditGroupPopup={this.toggleEditGroupPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleCampaignPopup ?
                            <CampaignPopup reopenFlag={this.state._reopenFlag} disEmail={this.state.DisEmail} userType={this.state.assignType} allData={this.state._allData} userLists={this.state.ManageUserList} chkUser={this.state.confirmUser} text={'Manage ' + this.state.SelectedGroup} dIndex={this.state.deleteIndex} confirmationText={this.state.confirmDelete} openBrokerSignature={this.brokerSignaturePopup.bind(this)} openResetGroup={this.toogleResetGroupPopup.bind(this)} cSearch={this.state.mGroupSearchText} cPagin={this.state.manageGroupPagin} SelectedGroupNumber={this.state.SelectedGroup} MaxComm={this.state.TopCommission} openManageGroup={this.toggleNewDisPopup.bind(this)} closeCampaignPopup={this.toggleCampaignPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleAssignGroupPopup ?
                            <AssignGroupPopup allData={this.state._allData} openCampaignPopup={this.toggleCampaignPopup.bind(this)} openEditScreenPopup={this.toggleEditGroupPopup.bind(this)} userLists={this.state.ManageUserList} chkUser={this.state.confirmUser} text={'Assign Group Number'} dIndex={this.state.deleteIndex} confirmationText={this.state.confirmDelete} cSearch={this.state.mGroupSearchText} cPagin={this.state.manageGroupPagin} SelectedGroupNumber={this.state.SelectedGroup} MaxComm={this.state.TopCommission} openManageGroup={this.toggleNewDisPopup.bind(this)} closeAssignGroupPopup={this.toggleAssignGroupPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleResetScreenPopup ?
                            <ConfirmationPopup userList={this.state.ManageUserList} dIndex={this.state.deleteIndex} openEditGroup={this.toggleEditGroupPopup.bind(this)} closeResetPopup={this.toogleResetGroupPopup.bind(this)} SelectedGroupNumber={this.state.SelectedGroup} cSearch={this.state.mGroupSearchText} cPagin={this.state.manageGroupPagin} HeadingText={this.state.confirmationText} openManageGroup={this.toggleNewDisPopup.bind(this)} popupName={this.state.confirmSection} /> : null
                    }
                    {
                        this.state.DeletePopup ?
                            <DeletePopup manageUserPassword={this.state.ManageUserPassword} manageUserPagin={this.state.ManageUserPagin} manageUserSearch={this.state.ManageUserSearch} openManageUser={this.toggleManageUserPopup.bind(this)} manageUserName={this.state.ManageUserName} manageUserEmail={this.state.ManageUserEmail} manageUserId={this.state.ManageUserId} confirmSection={this.state.ManageUserSection} popupName={this.state.confirmSection} titleText={this.state.ManageUserTitleText} closePopup={this.deletePopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleSignaturePopup ?
                            <BrokerSignaturePopup cSearch={this.state.mGroupSearchText} cPagin={this.state.manageGroupPagin} MaxComm={this.state.TopCommission} userLists={this.state.ManageUserList} dIndex={this.state.deleteIndex} confirmationText={this.state.confirmDelete} text={this.state.brokerUserName + ': Signature Details'} GroupNumber={this.state.SelectedGroup} openManageGroup={this.toggleNewDisPopup.bind(this)} openEditGroup={this.toggleEditGroupPopup.bind(this)} closeBrokerPopup={this.brokerSignaturePopup.bind(this)} /> : null
                    }
                    {
                        this.state.GlicApiPopup ?
                            <GlicApi text='Glic Health API' protectedData={this.state.safeData} glicData={this.state.glicApiData} glicIps={this.state.glicApiIPs} closeGlicPopup={this.toggleGlicApiPopup.bind(this)} ipListUpdated={() => this.GetWh_GlicAPI(parseInt(this.state.userdata.wholesaler_Id), this.state.userdata.email)} openApiAddModal={this.toggleGlicApiAddPopup.bind(this)} /> : null
                    }
                    {
                        this.state.addApiModalToggle ?
                            <GlicAddApi text={`Add Whitelisted ${(this.state.glicApiIPs.length && this.state.glicApiIPs[0].sType === 'Dynamic IP') || this.state.stype ? "Domain" : "IP's"}`} protectedData={this.state.safeData} glicData={this.state.glicApiData} closeGlicAddApiPopup={this.toggleGlicApiAddPopup.bind(this)} glicIps={this.state.glicApiIPs} ipAddressUpdated={() => this.GetWh_GlicAPI(parseInt(this.state.userdata.wholesaler_Id), this.state.userdata.email)} /> : null
                    }
                </div>
            </div>
        )

    }

}
export default Tools;